module.exports = __webpack_public_path__ + "static/Examine-1200ce65f428798ccdf6d462a2e4dae3.svg";